import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

import Tag from "@meetyoo/components/src/components/Tag";
import TableConfigurator from "../TableLayout/TableConfigurator";

const TableSelectModalComponent = ({ onClick, open, onClose, ownTableLayout, translate }) => {
  const theme = useTheme();
  return (
    <Modal
      open={open}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClose={() => {
        onClose();
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            width: "750px",
            backgroundColor: "#eee",
            border: "2px solid #000",
            boxShadow: theme.shadows[5],
            p: theme.spacing(2, 4, 3),
          }}
        >
          <Box sx={{ display: "flex", maxWidth: "100%", flexWrap: "wrap" }}>
            {Object.keys(TableConfigurator).map(
              item =>
                !["title", "customer", "lastContactAt", "owner", "webcastID", "orderID"].includes(item) && (
                  <Box
                    aria-hidden
                    key={item}
                    role="button"
                    sx={{
                      cursor: "pointer",
                      pr: theme.spacing(0.5),
                      pt: theme.spacing(0.5),
                    }}
                    onClick={() => onClick(item)}
                  >
                    <Tag
                      text={translate[TableConfigurator[item].label]}
                      color={ownTableLayout.indexOf(item) !== -1 ? "rgb(0, 217, 0)" : "grey"}
                      size="big"
                    />
                  </Box>
                )
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};
TableSelectModalComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  ownTableLayout: PropTypes.array.isRequired,
  translate: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  translate: state.ui.translate,
});

const TableSelectModal = connect(mapStateToProps)(TableSelectModalComponent);

export default TableSelectModal;
